// extracted by mini-css-extract-plugin
export default {"recently-off-market-wrapper":"recently-off-market-wrapper-b452","hover":"hover-00ad","rented-marker":"rented-marker-3193","rented-text-wrapper":"rented-text-wrapper-1056"};